<template>
	<div class="RepliesAndComments_box">
		<div class="RepliesAndComments" @click.stop>
			<div class="header_box">
				<div class="title">{{ content_Box_Data.title }}</div>
				<div class="el-icon-close" @click.stop="closureFun()"></div>
			</div>
			<div class="Source_content_box">
				<div class="user_box">
					<div class="avatar"  @click.stop="check_information_other(content_Box_Data)">
						<img v-if="content_Box_Data && content_Box_Data.avatar && content_Box_Data.avatar != ''" :src="content_Box_Data.avatar" :alt="'TOZO Community ' + content_Box_Data.nickname + ' User Avatar'"/>
						<i v-else class="el-icon-s-custom"></i>
					</div>
					<div class="comment_user_box">
						<div class="comment_user_name">{{ content_Box_Data.nickname }}</div>
						<div class="release_time">{{ $fun.formatTime(content_Box_Data.public_time) }}</div>
					</div>
				</div>
				<div class="reply_cmt">{{ content_Box_Data.content }}</div>
			</div>
			
			<div class="reply_content_box">
				<div class="avatar"  @click.stop="check_information_user(userinfo)">
					<img v-if="userinfo && userinfo.avatar && userinfo.avatar  != ''" :src="userinfo.avatar" :alt="'TOZO Community ' + userinfo.nickname + ' User Avatar'"/>
					<i v-else class="el-icon-s-custom"></i>
				</div>
				<div class="reply_content">
					<textarea ref="autoFocusTextarea" aria-label="auto Focus Textarea" v-model="PublishContent" :placeholder="placeholder" rows="1" maxlength="500" @input="adjustHeight" class="auto-expand-textarea"></textarea>
					<!-- <div class="custom-input" contenteditable="true" @input="handleInput" ref="autoFocusTextarea">
					  <div v-if="!PublishContent" class="default-text">{{ placeholder }}</div>
					</div> -->
				</div>
			</div>
			<div class="bottom_box">
				<button class="post_btn" :class="isSubmitting ? 'no_drop' : 'pointer'" :disabled="isSubmitting" @click="submitForm" >
				   {{ isSubmitting ? $t('buttonArr.Send') : $t('buttonArr.Send') }}
				</button>
			</div>
		</div>
	</div>
</template>

<script>

import { 
	post_community_postcomments, //帖子评论列表
	post_community_replycomments, //回复评论列表
	post_community_addcomment, //发布评论
	post_community_replycomment, //回复评论
	post_community_commentthumb, //点赞评论
	post_community_delcomment, //删除评论
	
	} from '@/api/community.js'
export default {
	name: 'RepliesAndComments',

	props: {
		calling_modules: {
			type: String,
			default: ""
		},
		contentBoxData: {},
	},
	
	data() {
		return {
			userinfo: this.$store.state.userinfo,
			content_Box_Data: this.contentBoxData,
			PublishContent: "",
			isSubmitting: true,
			placeholder: this.$t('MessagesArr.Reply'),
		}
	},
	
	// 监听
	watch: {
    "contentBoxData": {
      handler: function (newValue, oldValue) {
		  this.content_Box_Data = this.contentBoxData
      },
      deep: true
    },
    "PublishContent": {
      handler: function (newValue, oldValue) {
		  this.get_empty()
      },
      deep: true
    },
	},
	
	// beforeCreate() {
		
	// }
	
	created () {
	  
	},
  
	mounted() {
		console.log(this.content_Box_Data)
		this.set_placeholder()
		this.$refs.autoFocusTextarea.focus();  // 自动聚焦
	},
  
	methods:{
		adjustHeight(event) {
			const textarea = event.target;
			textarea.style.height = 'auto';  // 重置高度
			textarea.style.height = textarea.scrollHeight + 'px';  // 根据内容设置高度
		},
		
		set_placeholder(){
			let text = this.content_Box_Data.type == "post_a_comment" ? "@ " : this.$t('MessagesArr.Reply')
			this.placeholder = `${text} ${ this.content_Box_Data.nickname } :`
		},
		
		// 实时处理输入内容
		// handleInput() {
		//   const autoFocusTextarea = this.$refs.autoFocusTextarea;
		//   this.PublishContent = autoFocusTextarea.innerText;
		// },
		
		
		// 提交内容
		submitForm() {
			this.isSubmitting = true;
			this.submissionStatus = null;
			console.log("提交的内容：", this.PublishContent);
		
			if(this.content_Box_Data.type == "post_a_comment"){
				this.post_community_addcomment()
			}else{
				this.post_community_replycomment()
			}
		},
		
		//发布评论
		post_community_addcomment(){
			if(this.Loading){ return }
			this.Loading = true
			let obj = {
				post_id: this.content_Box_Data.post_id, 
				content: this.PublishContent, 
			}
			post_community_addcomment(obj)
		   .then((res) => {
				console.log(res)
				if(res.code == 0){
					this.successfully()
				}else{
					this.exception_handling(res, "postreport")
				}
		   })
		   .catch((err) => {
				console.log(err)
				this.exception_handling(err, "postreport")
		   })
		},
		
		//回复别人的评论
		post_community_replycomment(){
			if(this.Loading){ return }
			this.Loading = true
			let obj = {
				comment_id: this.content_Box_Data.comment_id, 
				content: this.PublishContent, 
			}
			post_community_replycomment(obj)
		   .then((res) => {
				console.log(res)
				if(res.code == 0){
					this.successfully()
				}else{
					this.exception_handling(res, "postreport")
				}
		   })
		   .catch((err) => {
				console.log(err)
				this.exception_handling(err, "postreport")
		   })
		},
		
		//成功处理
		successfully(err){
			this.$message(this.$t('tipsArr.Send_successfully'), 'success')
			let that = this
			setTimeout(()=>{
				that.closureFun("success")
			}, 1000)
		},
		
		//异常处理
		exception_handling(err){
			this.Loading = false
			this.$errorMessage(err)
			// this.$message(this.$t('tipsArr.System_Error'), 'error')
			// this.$message('err.data.message', 'error')
		},

		get_empty(){
			const publishContent = this.PublishContent.trim(); // 去除首尾空格
			if(publishContent != ''){
				this.isSubmitting = false
			}else{
				this.isSubmitting = true
			}
		},
		
		//查看 粉丝或关注人信息
		check_information_other(item){
		  console.log(item)
			let routeParams = {
				name: this.$store.state.userinfo.user_id == item.user_id ? "user-profile" : "users",
				params: {
					user_id: item.user_id,
					nickname: item.nickname,
				}
			};
			if (this.$route.name === 'home') {
				routeParams.params.previous = "posts-list";
			}else if (this.$route.name === 'users') {
				routeParams.name = "user-post-details"
				let path = this.$router.currentRoute.path
				let previous = path ? path.split("/")[1] : ''
				routeParams.params.previous = previous;
				
				let user = path ? path.split("/")[2] : ''
				if(user){
					routeParams.params.user = user;
				}
			}else{
				let path = this.$router.currentRoute.path
				let previous = path ? path.split("/")[1] : ''
				routeParams.params.previous = previous;
			}
			this.$router.push(routeParams);
		},
		
		// //查看 粉丝或关注人信息
		// check_information_other(item){
		// 	console.log(item)
		// 	this.$router.push({
		// 		name: "users",
		// 		params: {
		// 			user_id: item.user_id,
		// 			nickname: item.nickname,
		// 		}
		// 	})
		// },
		
		//查看 粉丝或关注人信息
		check_information_user(item){
			console.log(item)
			this.$router.push({
				name: "user-profile",
				params: {
					// nickname: item.nickname,
					// user_id: item.reply_user_id,
				}
			})
		},
		
		// 关闭
		closureFun(type){
			let state = type ? type : ''
			this.$emit("closureFun", state)
		}
	}
}
</script>

<style lang="less" scoped>
	*{
		box-sizing: border-box;
		font-family: Poppins, Poppins;
	}
	.RepliesAndComments_box{
		background-color: #ffffff;
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #999;
		padding: 10px 10px;
		font-size: 14px;
		background-color: rgba(0, 0, 0, 0.2);
		position: fixed;
		top: 0;
		left: 0;
		height: 100%;
		z-index: 999999;
	}
	.RepliesAndComments{
		width: 100%;
		border-radius: 8px;
		background-color: #ffffff;
		padding: 10px 10px;
		position: relative;
	}
	
	.header_box{
		display: flex;
		justify-content: center;
		height: 30px;
		align-items: center;
		width: 100%;
		position: relative;
		.title{
			font-size: 18px;
			color: #333333;
		}
	}
	.el-icon-close{
		position: absolute;
		right: 0px;
		top: 0px;
		height: 30px;
		width: 30px;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 24px;
		cursor: pointer;
		color: #999999;
	}
	.Source_content_box{
		margin-top: 30px;
	}
	.user_box{
		display: flex;
	}
	.avatar{
		width: 40px;
		height: 40px;
		cursor: pointer;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #505050;
		border-radius: 50%;
		overflow: hidden;
		img{
			width: 100%;
			height: 100%;
		}
		.el-icon-s-custom{
			height: 40px;
			display: flex;
			justify-content: center;
			align-items: center;
			width: 100%;
			height: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
			border: 1px #f5f5f5 solid;
			border-radius: 50%;
			font-size: 20px;
			color: #999;
		}
	}
	.comment_user_box{
		width: calc(100% - 55px);
		margin-left: 15px;
		color: #333333;
	}
	.comment_user_name{
		width: 100%;
		cursor: text;
		display: flex;
		flex-wrap: wrap;
		font-size: 16px;
	}
	.release_time{
		margin-top: 3px;
		font-size: 10px;
		color: #666666;
		// color: #999999;
	}
	.reply_cmt{
		color: #333333;
		margin-left: 55px;
		width: calc(100% - 55px);
		margin-top: 20px;
		font-size: 14px;
	}
	.bottom_box{
		position: absolute;
		bottom: 10px;
		left: 10px;
		width: calc(100% - 20px);
		height: 40px;
		display: flex;
		justify-content: flex-end;
	}
	.reply_content_box{
		margin-top: 50px;
		display: flex;
		.reply_content{
			width: calc(100% - 55px);
			margin-top: 5px;
			margin-left: 15px;
		}
		.custom-input{
			font-size: 14px;
			color: #333333;
		}
		.default-text{
			color: #999999;
		}
		.auto-expand-textarea {
			width: 100%;
			overflow: hidden;
			resize: none;
			padding: 2px 5px;
			border: 0px;
			border: 1px solid #f5f5f5;
			border-radius: 4px;
			box-sizing: border-box;
			font-size: 14px;
			line-height: 1.5;
			min-height: 100px; /* 初始高度 */
			max-height: 400px; /* 设置一个最大高度 */
		}
	}
     .post_btn {
        height: 36px;
        padding: 0px 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        min-width: 100px;
        background: #06f;
        // background: #2094FA;
        border-radius: 999px 999px 999px 999px;
        font-weight: 400;
        font-size: 12px;
        color: #FFFFFF;
        line-height: 14px;
        text-align: center;
        font-style: normal;
        text-transform: none;
		  border: 0;
      }
		button:disabled{
			background-color: #999999;
		}
		.pointer{
			cursor: pointer;
		}
		.no_drop{
			cursor: no-drop;
		}
	@media screen and (min-width: 1024px) {
		
		.RepliesAndComments{
			max-width: 800px;
			max-height: calc(100vh - 20px);
			min-height: calc(60vh);
		}
	}
	@media screen and (max-width: 1024px) {
		.RepliesAndComments{
			max-width: 100%;
			height: calc(100vh - 20px);
		}
	}
</style>
